import { Navigate, Outlet } from 'react-router-dom'
import { useGuiPlay } from '../state/GuiPlayContext'

const ELEVATION_KEY = 'gp_parent_elevated_until'

export function elevateParentArea(): void {
  sessionStorage.setItem(ELEVATION_KEY, String(Date.now() + 15 * 60_000))
}

export function AdultRoute() {
  const { guardian, loading } = useGuiPlay()
  if (loading) return null
  if (!guardian) return <Navigate to="/access" replace />
  const elevatedUntil = Number(sessionStorage.getItem(ELEVATION_KEY) ?? 0)
  if (!Number.isFinite(elevatedUntil) || elevatedUntil < Date.now()) {
    sessionStorage.removeItem(ELEVATION_KEY)
    return <Navigate to="/play" replace />
  }
  return <Outlet />
}
